import { render, staticRenderFns } from "./member-records.vue?vue&type=template&id=9e8581bc&"
import script from "./member-records.vue?vue&type=script&lang=js&"
export * from "./member-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports